import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c26608a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-items-center tw-justify-between tw-pr-[23.5px]" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-leading-[130%] tw-w-full tw-text-[#211F58] tw-text-[15px] tw-font-semibold tw-not-italic" }
const _hoisted_3 = { class: "tw-p-[15px] tw-w-[247px]" }
const _hoisted_4 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_5 = { class: "title-note" }
const _hoisted_6 = { class: "tw-mt-[10px] tw-text-[11px] tw-font-[400] tw-text-[#878787] tw-whitespace-pre-line" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "tw-mt-[14px] tw-flex" }
const _hoisted_9 = { class: "tw-w-[161px]" }
const _hoisted_10 = { class: "tw-flex tw-items-center tw-justify-between tw-mb-[6px]" }
const _hoisted_11 = { class: "tw-mb-[0px] tw-text-[13px] tw-leading-[130%] tw-font-medium tw-text-[#211F58]" }
const _hoisted_12 = { class: "tw-mb-[0px] tw-text-[13px] tw-leading-[130%] tw-font-normal tw-text-[#878787]" }
const _hoisted_13 = { class: "tw-flex tw-items-center tw-justify-between tw-mb-[6px]" }
const _hoisted_14 = { class: "tw-mb-[0px] tw-text-[13px] tw-leading-[130%] tw-font-medium tw-text-[#211F58]" }
const _hoisted_15 = { class: "tw-mb-[0px] tw-text-[13px] tw-leading-[130%] tw-font-normal tw-text-[#878787]" }
const _hoisted_16 = {
  key: 0,
  class: "tw-flex-[1] tw-relative tw-top-[-27px] tw-ml-[20px] tw-mr-[4px]"
}

import { getComponentUiText } from "@/utils/utilities";
import { ApexOptions } from "apexcharts";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import { onMounted, PropType, Ref, ref, watch } from "vue";
import LineChart, { IChartSeries } from "../chart/lineChart.vue";
import { TYPE_ISSUE_OVER_TIME_MINI_GRAPH_OPTIONS } from "@/utils/constants";
import { getMarkers } from "@/utils/apexChart";
import { cloneDeep } from "lodash";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";


export default /*#__PURE__*/_defineComponent({
  __name: 'issuesOverTimeMiniGraph',
  props: {
  severity: {
    type: Array as PropType<Array<any>>,
    required: true,
  },
  id: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const filterSelected = ref(TYPE_ISSUE_OVER_TIME_MINI_GRAPH_OPTIONS.Total);
const option: Ref<ApexOptions> = ref({});
const series: Ref<IChartSeries[]> = ref([]);
const resolveLastRun: Ref<string> = ref("");
const resolveVelocity: Ref<string> = ref("");

const dropdownData = [
  {
    name: getComponentUiText(
      "app-component-assessments-assessment-question-total-score-1",
    ),
    value: TYPE_ISSUE_OVER_TIME_MINI_GRAPH_OPTIONS.Total,
  },
  {
    name: getComponentUiText(
      "app-component-assessments-checklists-exposures-card-2",
    ),
    value: TYPE_ISSUE_OVER_TIME_MINI_GRAPH_OPTIONS.Critical,
  },
  {
    name: getComponentUiText("app-assess-recommendations-high-risk-1"),
    value: TYPE_ISSUE_OVER_TIME_MINI_GRAPH_OPTIONS.High,
  },
  {
    name: getComponentUiText("app-assess-recommendations-medium-risk-1"),
    value: TYPE_ISSUE_OVER_TIME_MINI_GRAPH_OPTIONS.Medium,
  },
  {
    name: getComponentUiText("app-assess-recommendations-low-risk-1"),
    value: TYPE_ISSUE_OVER_TIME_MINI_GRAPH_OPTIONS.Low,
  },
];

onMounted(() => {
  onProceedData();
});

watch(
  () => props.severity,
  () => {
    onProceedData(filterSelected.value);
  },
);

const onProceedData = (
  type = TYPE_ISSUE_OVER_TIME_MINI_GRAPH_OPTIONS.Total,
) => {
  const dataArray = props.severity;
  const filterData = dataArray
    .sort((a: any, b: any) => a.startedAt - b.startedAt)
    .map((item) => {
      return item[type];
    });
  if (!props.severity || props.severity.length <= 1) {
    resolveLastRun.value = "N/A";
    resolveVelocity.value = "N/A";
    return;
  }
  resolveLastRun.value = `${
    dataArray[dataArray.length - 2][type] -
    dataArray[dataArray.length - 1][type]
  }`;
  resolveVelocity.value = Number(
    (dataArray[0][type] - dataArray[dataArray.length - 1][type]) /
      (dataArray.length - 1),
  ).toFixed(2);
  let markers = getMarkers(cloneDeep(filterData), cloneDeep(filterData), true);
  markers = markers.map((item) => {
    return {
      ...item,
      size: 0,
    };
  });

  const maxScore = Math.max(...dataArray);
  const minScore = Math.min(...dataArray);

  const fiftyPercentile = (maxScore + minScore) * 0.5;

  series.value = [
    {
      name: getComponentUiText("app-scan-scanning-issues-number-block-1"),
      data: filterData,
    },
  ];

  option.value = {
    stroke: { width: 3, curve: "straight" },
    chart: { toolbar: { show: false } },
    tooltip: {
      x: {
        formatter: function (value) {
          return convertUTCTimeToLocalTime(
            dataArray[value - 1].startedAt,
            undefined,
            "HH:mm",
          );
        },
      },
      y: {
        formatter: function (value) {
          return Number(value).toFixed(0);
        },
      },
    },
    yaxis: {
      show: false,
    },
    xaxis: {
      labels: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      tooltip: {
        enabled: false,
      },
      crosshairs: {
        show: false,
      },
    },

    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        type: "vertical",
        inverseColors: true,
        colorStops: [
          {
            offset: 0,
            color: "#F70000",
            opacity: 1,
          },
          {
            offset: fiftyPercentile,
            color: "#FFA300",
            opacity: 1,
          },
          {
            offset: 100,
            color: "#01893D",
            opacity: 1,
          },
        ],
      },
    },
    grid: {
      show: false,
      padding: { left: 10, right: 20, top: 0, bottom: 10 },
    },
  };
};

const onFiltered = (e) => {
  onProceedData(e.target.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(_unref(getComponentUiText)("app-scanning-page-issue-over-time-title-1")) + " ", 1),
        _createVNode(ButtonShowDuplicateAssessment, {
          "id-popover": 'popover-issue-over-time-mini-graph-' + __props.id,
          classes: `tw-ml-[10px] tw-mb-[2px]`
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(getComponentUiText)("app-scanning-page-issue-over-time-title-1")), 1)
              ]),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(getComponentUiText)(
                "app-scanning-page-mini-chart-note-description-1",
              )), 1)
            ])
          ]),
          _: 1
        }, 8, ["id-popover"])
      ]),
      _createElementVNode("select", {
        class: "right-title tw-relative",
        onInput: _cache[0] || (_cache[0] = (e) => onFiltered(e))
      }, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(dropdownData, (data, index) => {
          return _createElementVNode("option", {
            key: index,
            value: data.value,
            class: "tw-text-[#211F58] tw-text-center tw-text-[11px] tw-font-medium tw-leading-[8px]"
          }, _toDisplayString(data.name), 9, _hoisted_7)
        }), 64))
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(getComponentUiText)(
              "app-scanning-page-mini-chart-resolved-last-run-1",
            )), 1),
          _createElementVNode("p", _hoisted_12, _toDisplayString(resolveLastRun.value), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(getComponentUiText)(
              "app-scanning-page-mini-chart-resolved-velocity-1",
            )), 1),
          _createElementVNode("p", _hoisted_15, _toDisplayString(resolveVelocity.value), 1)
        ])
      ]),
      (__props.severity && __props.severity.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createVNode(LineChart, {
              height: 90,
              series: series.value,
              "chart-options": option.value
            }, null, 8, ["series", "chart-options"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})